import React from 'react'

export default function RadioInput(props) {
    function handleClick(value) {
        console.log("Clicked")
        props.onChange({
            target: {
                name: props.name,
                value: value,
                type: "radio"
            }
        })
    }

    const errorStyle = {
        border: (props.formData.error.questions[props.questionNum]) ? 'solid 2px #FD625E' : 'solid 2px #E4EBF3'
    }

    return (
        <form className="RadioInput">
            <h2 className="RadioInput--question" for={props.name}>I see myself as someone who</h2>
            <div className="RadioInput--options">
                <div className="RadioInput--option-container" onClick={() => handleClick("optiona")} style={errorStyle}>
                    <div className="RadioInput--content-container">
                        <input
                            className="RadioInput--input"
                            type="radio"
                            id={"optiona"}
                            name={`${props.name}`}
                            value={"optiona"}
                            onChange={props.onChange}
                            checked={props.formData.questions[props.questionNum].answer === "optiona"}
                        />
                        <label className="RadioInput--label" htmlFor="question1">{props.optiona}</label>
                    </div>
                </div>
                <div className="RadioInput--option-container" onClick={() => handleClick("optionb")} style={errorStyle}>
                    <div className="RadioInput--content-container">
                        <input
                            className="RadioInput--input"
                            type="radio"
                            id={"optionb"}
                            name={`${props.name}`}
                            value={"optionb"}
                            onChange={props.onChange}
                            checked={props.formData.questions[props.questionNum].answer === "optionb"}
                        />
                        <label className="RadioInput--label" htmlFor="question1">{props.optionb}</label>
                    </div>
                </div>
            </div>

        </form >
    )
}